import { getCookie, erase } from "../../global-functions/cookieFunction";
import { closeGroupBill, freezOff, resetSplitOptions } from ".";
import { setPickupOrDelivery } from "../action-creater";

  export const cleanLimitedState = (type='dine-in') => {
  return async (dispatch) => {
    dispatch({ type: "setCampaignState", campaignState: [] });
    dispatch({ type: "setOptionalRewardsDetails", optionalRewardsDetials: [] });
    dispatch({
      type: "setSelectLoyaltyCardPopup",
      selectLoyaltyCardPopup: false,
    });
    dispatch({
      type: "setInvoiceTaxesChargesExtras",
      invoiceTaxesChargesExtras: [],
    });
    dispatch({ type: "setLoyaltyRewardObj", loyaltyRewardObj: {} });
    dispatch({ type: "setShopMode", shopMode: [] });
    dispatch({ type: "setGuestLoggedIn", guestLoggedIn: false });
  };
  };

  // Clean and Reset all Cookies and localStorage related orders
  export const cleanRest = (
  state,
  response,
  orders,
  history,
  type = "dine-in",
  
  ) => {
  return async (dispatch) => {
    localStorage.removeItem(`${state.storeInfo.slug}_cart`);
    localStorage.removeItem(`${state.storeInfo.slug}_form`);
    dispatch(closeGroupBill(state.storeInfo.slug));
    dispatch({ type: "updateCart", cart: [] });
    dispatch({ type: "SET_FORM_DATA", formData: [] });
    dispatch({ type: "setOrderProdQty", orderProdQty: [] });
    dispatch({ type: "setGroupBillRes", groupBillRes: [] });
    dispatch({ type: "updateSubTotal", subTotal: 0 });
    dispatch({ type: "SET_TABLE", qrTable: null });
    dispatch({ type: "setLoginSkip", loginSkip: false });
    dispatch({ type: "setQrOptionStatus", qrOptionStatus: false });
    dispatch({ type: "setPayTablePopUp", payTablePopUp: false });
    dispatch({ type: "setCampaignState", campaignState: [] });
    dispatch({ type: "setOptionalRewardsDetails", optionalRewardsDetials: [] });
    dispatch({ type: "setPaymentPopUp", paymentPopUp: false });
    dispatch({ type: "setPayTableDiscount", payTableDiscount: 0 });
    dispatch({ type: "SET_COMO_REWARDS", comoRewards: null });
    dispatch({
      type: "setSelectLoyaltyCardPopup",
      selectLoyaltyCardPopup: false,
    });
    dispatch({
      type: "setInvoiceTaxesChargesExtras",
      invoiceTaxesChargesExtras: [],
    });
    dispatch({ type: "setLoyaltyRewardObj", loyaltyRewardObj: null });
    dispatch({ type: "setHotelMode", hotelMode: false, hotelQrCode: null });
    dispatch({ type: "setHotelObj", hotelObj: null });
    dispatch({ type: "setQrPickup", qrPickup: null });
    dispatch({ type: "setCombos", combos: [] });
    dispatch({ type: "setShareBill", shareBill: [] });
    dispatch({ type: "setShopMode", shopMode: [] });
    dispatch({ type: "setGuestLoggedIn", guestLoggedIn: false });
    dispatch({
      type: "setPayTableCharges",
      payTableCharges: 0,
      payTableTotalCharges: 0,
    });
    erase("Re-Order");
    
    if( type != 'delivery' && type != 'pickup') {
      dispatch({ type: "setIsAddToCartEnable", isAddToCartEnable: state.hospitalMode ? true :  false });
      dispatch({ type: "SET_BRANCH", qrBranch: null });
      dispatch({ type: "setDeliveryAddsInfo", deliveryAddsInfo: null });
      dispatch({ type: "setPickupAddsInfo", pickupAddsInfo: null });
      dispatch({ type: "SET_PICKUP_OR_DELIVERY", pickupOrDelivery: "delivery" })
    }

    if (response != null) {
      if (
        response.data.success === true &&
        response.data.data.url &&
        response.data.data.url != null
      ) {
        const winUrl = window.open(`${response.data.data.url}`, "_self");
        winUrl.focus();
        dispatch(resetSplitOptions());
      } else if (type === "delivery") {
        const winUrl = window.open(
          `${process.env.REACT_APP_PAY_URL}/delivery/${response?.data?.data?.service?.invoice_id}`,
          "_self"
        );
        winUrl.focus();
        dispatch(resetSplitOptions());
      } else if (type === "pickup") {
        if(state?.storeInfo?.hospitalMode){
          dispatch({
            type: "SHOW_ALERT",
            alertType: "success",
            message: response.data.message,
          });
          history.push('/')
        }else{
          const winUrl = window.open(
            `${process.env.REACT_APP_PAY_URL}/pickup/${response?.data?.data?.service?.invoice_id}`,
            "_self"
          );
          winUrl.focus();
        }
        dispatch(resetSplitOptions());
      } else {
        if (response.data.success === true) {
          dispatch({
            type: "SHOW_ALERT",
            alertType: "success",
            message: response.data.message,
          });
        } else {
          dispatch({
            type: "SHOW_ALERT",
            alertType: "error",
            message: response.data.message,
          });
        }

        if (response.data.success === true) {
          dispatch({
            type: "setReviewModal",
            reviewModal: false,
          });
        }
        dispatch(freezOff());

        history.push("/");
      }
    } else {
      dispatch(freezOff());

      history.push("/");
    }
  };
  };

  // Clean cookies and localstorage and sessions when updated version found
  export const cleanCache = (state) => {
  return async (dispatch) => {
    erase("tokenAuth");
    erase("Re-order");
    erase("Profile");
    [`hotel`, `pickUp`, `dineIn`, `menu`].forEach((item) => {
      localStorage.removeItem(`${state.storeInfo.slug}_${item}_cart`);
      localStorage.removeItem(`${state.storeInfo.slug}_${item}_form`);
    });
    localStorage.removeItem("userInfo");
    localStorage.setItem("loggedIn", false);
    dispatch({ type: "updateCart", cart: [] });
    dispatch({ type: "updateSubTotal", subTotal: 0 });
    dispatch({ type: "setQrRequired", qrRequired: false });
    dispatch({ type: "SET_LOGOUT" });
    dispatch({ type: "SET_USERINFO", userInfo: [] });
    dispatch({ type: "SET_FORM_DATA", formData: [] });
    dispatch({ type: "SET_TABLE", qrTable: null });
    dispatch({ type: "SET_BRANCH", qrBranch: null });
    dispatch({ type: "SET_PRODUCTS", products: [] });
    dispatch({ type: "setDeliveryAddsInfo", deliveryAddsInfo: null });
    dispatch({ type: "setPickupAddsInfo", pickupAddsInfo: null });
    dispatch({ type: "SET_PICKUP_OR_DELIVERY", pickupOrDelivery: "delivery" })
  };
  };


  export const handlePromotionBannerBySession = (state) => {
    return async (dispatch) => {
      const popupClosed = sessionStorage.getItem(`adPopupClosed${state.storeInfo.slug}`);
      if (!popupClosed) {
        // Show popup if not closed yet in this tab
        dispatch({ type: "setPromotionBanner", promotionBanner: true });
      }
      else{
        dispatch({ type: "setPromotionBanner", promotionBanner: false });
      }
    };
  };